module.exports = __webpack_public_path__ + "static/assets/ec6902c94871a47a95153ab8cab454cd.png";